import { useLocation, Wrapper } from "nystem-components";
import app from "nystem";

const Link = ({ to, className, match, children }) => {
  to = app.getVanity2Url(to);
  match = app.getVanity2Url(match);

  const { isMatch, pathname, search } = useLocation(match || to);

  if ((to === pathname || !to) && !search)
    return (
      <Wrapper className={[className, isMatch && "active"]}>{children}</Wrapper>
    );

  to = app.getUrl2Vanity(to);
  return (
    <Wrapper
      renderAs="a"
      href={to || "/"}
      className={[className, isMatch && "active"]}
      onClick={(event) => {
        event.preventDefault();
        window.history.pushState({}, "", to);
      }}
    >
      {children}
    </Wrapper>
  );
};
export default Link;
